import { render, staticRenderFns } from "./FormaPagamentoManage.vue?vue&type=template&id=1f5eb976&scoped=true"
import script from "./FormaPagamentoManage.vue?vue&type=script&lang=js"
export * from "./FormaPagamentoManage.vue?vue&type=script&lang=js"
import style0 from "./FormaPagamentoManage.vue?vue&type=style&index=0&id=1f5eb976&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5eb976",
  null
  
)

export default component.exports